import React from "react";
import { useReactAppState } from "../../../shared/containers/utils";
import { useDateDisplay } from "../../utils";
import {
  StyledMatchListHeader,
  StyledMatchListHeaderDate,
  StyledMatchListHeaderTimezone,
} from "./StyledMatchListHeader";

export const MatchListHeader = ({
  matchDate,
  dateRangeType,
  showTimezone = false,
}) => {
  const { t } = useReactAppState();
  const dateDisplay = useDateDisplay(matchDate, dateRangeType);
  return (
    <StyledMatchListHeader>
      <StyledMatchListHeaderDate>{dateDisplay}</StyledMatchListHeaderDate>
      {showTimezone && (
        <StyledMatchListHeaderTimezone>
          {t("match_schedule_timezone")}
        </StyledMatchListHeaderTimezone>
      )}
    </StyledMatchListHeader>
  );
};
